module.exports = __webpack_public_path__ + "img/skill.297f8f12.svg";